module.exports = __webpack_public_path__ + "static/media/1_pl.0df137f4.png";